import { LANGUAGE } from '../../constants/localStorage';
import { getData } from '../../services/storage';
import { refundPolicyBnData, refundPolicyData } from '../../utils';
import { getLocaleString } from '../../utils/locales';

export const RefundPolicy = () => {
  const locale = getData(LANGUAGE);
  const data = locale === 'en' ? refundPolicyData : refundPolicyBnData
  return (
    <div className="my-5 mx-5 text-justify pt-12 lg:pt-16 md:pt-16">
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <title>{getLocaleString('refund_policy', locale)}</title>
      
      <style
        type="text/css"
        dangerouslySetInnerHTML={{
          __html:
            ' * {margin:0; padding:0; text-indent:0; }\n h1 { color: #333; font-family:"Times New Roman", serif; font-style: normal; font-weight: bold; text-decoration: none; font-size: 11pt; }\n .p, p { color: #333;  font-size: 11pt; margin:0pt; }\n li {display: block; }\n #l1 {padding-left: 0pt;counter-reset: c1 1; }\n #l1> li>*:first-child:before {counter-increment: c1; content: counter(c1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l1> li:first-child>*:first-child:before {counter-increment: c1 0;  }\n #l2 {padding-left: 0pt;counter-reset: c2 1; }\n #l2> li>*:first-child:before {counter-increment: c2; content: counter(c2, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l2> li:first-child>*:first-child:before {counter-increment: c2 0;  }\n #l3 {padding-left: 0pt;counter-reset: c3 1; }\n #l3> li>*:first-child:before {counter-increment: c3; content: counter(c3, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l3> li:first-child>*:first-child:before {counter-increment: c3 0;  }\n #l4 {padding-left: 0pt;counter-reset: c4 1; }\n #l4> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l4> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l5 {padding-left: 0pt;counter-reset: c4 1; }\n #l5> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l5> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l6 {padding-left: 0pt;counter-reset: c4 1; }\n #l6> li>*:first-child:before {counter-increment: c4; content: counter(c4, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l6> li:first-child>*:first-child:before {counter-increment: c4 0;  }\n #l7 {padding-left: 0pt;counter-reset: d1 1; }\n #l7> li>*:first-child:before {counter-increment: d1; content: counter(d1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l7> li:first-child>*:first-child:before {counter-increment: d1 0;  }\n li {display: block; }\n #l8 {padding-left: 0pt;counter-reset: e1 4; }\n #l8> li>*:first-child:before {counter-increment: e1; content: counter(e1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l8> li:first-child>*:first-child:before {counter-increment: e1 0;  }\n #l9 {padding-left: 0pt;counter-reset: e2 1; }\n #l9> li>*:first-child:before {counter-increment: e2; content: counter(e2, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l9> li:first-child>*:first-child:before {counter-increment: e2 0;  }\n li {display: block; }\n #l10 {padding-left: 0pt;counter-reset: f1 1; }\n #l10> li>*:first-child:before {counter-increment: f1; content: counter(f1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l10> li:first-child>*:first-child:before {counter-increment: f1 0;  }\n #l11 {padding-left: 0pt;counter-reset: g1 5; }\n #l11> li>*:first-child:before {counter-increment: g1; content: counter(g1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l11> li:first-child>*:first-child:before {counter-increment: g1 0;  }\n #l12 {padding-left: 0pt;counter-reset: h1 1; }\n #l12> li>*:first-child:before {counter-increment: h1; content: counter(h1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l12> li:first-child>*:first-child:before {counter-increment: h1 0;  }\n #l13 {padding-left: 0pt;counter-reset: h2 1; }\n #l13> li>*:first-child:before {counter-increment: h2; content: counter(h2, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l13> li:first-child>*:first-child:before {counter-increment: h2 0;  }\n #l14 {padding-left: 0pt;counter-reset: i1 1; }\n #l14> li>*:first-child:before {counter-increment: i1; content: counter(i1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l14> li:first-child>*:first-child:before {counter-increment: i1 0;  }\n #l15 {padding-left: 0pt;counter-reset: j1 1; }\n #l15> li>*:first-child:before {counter-increment: j1; content: counter(j1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l15> li:first-child>*:first-child:before {counter-increment: j1 0;  }\n #l16 {padding-left: 0pt;counter-reset: k1 1; }\n #l16> li>*:first-child:before {counter-increment: k1; content: counter(k1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l16> li:first-child>*:first-child:before {counter-increment: k1 0;  }\n #l17 {padding-left: 0pt;counter-reset: l1 1; }\n #l17> li>*:first-child:before {counter-increment: l1; content: counter(l1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l17> li:first-child>*:first-child:before {counter-increment: l1 0;  }\n #l18 {padding-left: 0pt;counter-reset: m1 1; }\n #l18> li>*:first-child:before {counter-increment: m1; content: counter(m1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l18> li:first-child>*:first-child:before {counter-increment: m1 0;  }\n li {display: block; }\n #l19 {padding-left: 0pt;counter-reset: n1 7; }\n #l19> li>*:first-child:before {counter-increment: n1; content: counter(n1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l19> li:first-child>*:first-child:before {counter-increment: n1 0;  }\n #l20 {padding-left: 0pt;counter-reset: o1 1; }\n #l20> li>*:first-child:before {counter-increment: o1; content: counter(o1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l20> li:first-child>*:first-child:before {counter-increment: o1 0;  }\n #l21 {padding-left: 0pt;counter-reset: p1 1; }\n #l21> li>*:first-child:before {counter-increment: p1; content: counter(p1, lower-roman)". "; color: #333;  font-size: 10pt; }\n #l21> li:first-child>*:first-child:before {counter-increment: p1 0;  }\n #l22 {padding-left: 0pt;counter-reset: o1 3; }\n #l22> li>*:first-child:before {counter-increment: o1; content: counter(o1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l22> li:first-child>*:first-child:before {counter-increment: o1 0;  }\n #l23 {padding-left: 0pt;counter-reset: q1 1; }\n #l23> li>*:first-child:before {counter-increment: q1; content: counter(q1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l23> li:first-child>*:first-child:before {counter-increment: q1 0;  }\n li {display: block; }\n #l24 {padding-left: 0pt;counter-reset: r1 1; }\n #l24> li>*:first-child:before {counter-increment: r1; content: counter(r1, lower-roman)". "; color: #333;  font-size: 11pt; }\n #l24> li:first-child>*:first-child:before {counter-increment: r1 0;  }\n',
        }}
      />
      <div className="text-uppercase font-900 font-bold flex justify-center text-black">
        {getLocaleString('gold_kinen_title', locale)}
      </div>
      <h1
        style={{
          paddingTop: '3pt',

          textIndent: '0pt',
          textAlign: 'center',
        }}
      >
        {getLocaleString('refund_policy_header', locale)}
      </h1>
      <p style={{ textIndent: '0pt', textAlign: 'left' }}>
        <br />
      </p>

      <ol id="l1">
        {data.map((item, idx) => (
          <li data-list-text="i.">
            <p
              style={{
                paddingTop: '9pt',
                paddingLeft: '23pt',
                textIndent: '-5pt',
                textAlign: 'left',
              }}
            >
              {item}
            </p>
          </li>
        ))}
        {/* <li data-list-text="ii.">
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
           {getLocaleString('refund_policy_2', locale)}
          </p>
        </li>
        <li data-list-text="iii.">
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {getLocaleString('refund_policy_3', locale)}
          </p>
        </li>
        <li data-list-text="iv.">
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {getLocaleString('refund_policy_4', locale)}
          </p>
        </li>
        <li data-list-text="v.">
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {getLocaleString('refund_policy_5', locale)}
          </p>
        </li>
        <li data-list-text="vi.">
          <p
            style={{
              paddingTop: '9pt',
              paddingLeft: '23pt',
              textIndent: '-5pt',
              textAlign: 'left',
            }}
          >
            {' '}
            {getLocaleString('refund_policy_6', locale)}
          </p>
        </li> */}
      </ol>
    </div>
  );
};
